import { AuthenticatedTemplate } from "@azure/msal-react";
import { RightArrow } from "@moneris-portal/svg-components";
import "./index.scss";
import StatusModal from "../../components/StatusModal";
import Hook from "./useQBO_Accounting";
import Footer from "../../components/QBO_Accounting/Footer";
import Header from "../../components/QBO_Accounting/Header";
import AccountSettingsSidebar from "../../components/QBO_Accounting/AccountSettingsSidebar";
import AccountSettingsModal from "../../components/QBO_Accounting/AccountSettingsModal";
import Accordion from "../../components/Accordion";
import ResponsiveLink from "@moneris-portal/responsive-link";
import qboFeatures from "../../assets/qbo_features.svg";
import qboHeroLogo from "../../assets/qbo_full_logo.svg";
import monerisHeroLogo from "../../assets/moneris_qbo_logo.png";
import monerisLogo from "../../assets/moneris_logo.svg";
import infoIcon from "../../assets/info_icon.svg";
import letterIcon from "../../assets/letter_icon.svg";
import Loader from "@moneris-portal/loader";
import { env } from "../../cfg/env";
import StraightforwardSetupIcon from "../../components/QBO_Accounting/FeatureIcons/StraightforwardSetupIcon";
import OvernightSyncIcon from "../../components/QBO_Accounting/FeatureIcons/OvernightSyncIcon";
import SingleLocationIcon from "../../components/QBO_Accounting/FeatureIcons/SingleLocationIcon";
import LiveSupportIcon from "../../components/QBO_Accounting/FeatureIcons/LiveSupportIcon";
import FreeTrialInfoIcon from "../../components/QBO_Accounting/FeatureIcons/FreeTrialInfoIcon";

function QBO_Accounting(props) {
  const { lang, history } = props;
  const {
    BLOCK,
    translate,
    statusModalState,
    QBOMonerisConnectionStatus,
    QBOSubscription,
    isPending,
    disconnectedStatusModal,
    disconnectErrorStatusModal,
    changePlanSuccess,
    cancelSubscriptionSuccess,
    reactivateSuccess,
    clearStatusFlag,
    dispatchStatusModalState,
    ffPassed,
    ffLoading,
  } = Hook.useQBO_Accounting(props);

  const handleCloseStatusModal = () => {
    dispatchStatusModalState({
      type: "setStateFromModalStatus",
      payload: null,
    });
  };

  // Show loader while feature flag is loading or not enabled
  if (ffLoading || !ffPassed) {
    return <Loader />;
  }

  return (
    <AuthenticatedTemplate>
      {statusModalState.status && (
        <StatusModal
          type={statusModalState.status}
          onClose={handleCloseStatusModal}
        />
      )}
      {disconnectedStatusModal && (
        <StatusModal
          type="disconnected"
          onClose={() => clearStatusFlag("disconnectedStatusModal")}
        />
      )}
      {disconnectErrorStatusModal && (
        <StatusModal
          type="disconnect-error"
          onClose={() => clearStatusFlag("disconnectErrorStatusModal")}
        />
      )}
      {changePlanSuccess && (
        <StatusModal
          type="change-plan-success"
          onClose={() => clearStatusFlag("changePlanSuccess")}
        />
      )}
      {cancelSubscriptionSuccess && (
        <StatusModal
          type="cancel-subscription-success"
          onClose={() => clearStatusFlag("cancelSubscriptionSuccess")}
        />
      )}
      {reactivateSuccess && (
        <StatusModal
          type="reactivate-success"
          onClose={() => clearStatusFlag("reactivateSuccess")}
        />
      )}
      <AccountSettingsSidebar
        lang={lang}
        connectionStatus={QBOMonerisConnectionStatus}
        subscription={QBOSubscription}
      />
      <AccountSettingsModal />
      <div className={BLOCK.current}>
        <Header
          lang={lang}
          history={history}
          isConnected={QBOMonerisConnectionStatus === "CONNECTED"}
          isLoading={QBOMonerisConnectionStatus === "LOADING"}
          subscription={QBOSubscription}
        />

        <div className={`${BLOCK.current}__page-content`}>
          <div className={`${BLOCK.current}__section`}>
            <div className={`${BLOCK.current}__left`}>
              <h2>{translate("table-of-contents")}</h2>
              <ResponsiveLink
                linkText={translate("summary-title")}
                link={"#summary"}
              />
              <ResponsiveLink
                linkText={translate("features-title")}
                link={"#features"}
              />
              <ResponsiveLink
                linkText={translate("pricing-landing-title")}
                link={"#pricing"}
              />
              <ResponsiveLink
                linkText={translate("how-to-guide-title")}
                link={"#how-to-guides"}
              />
            </div>
            <div id="summary" className={`${BLOCK.current}__content`}>
              {!QBOSubscription && QBOMonerisConnectionStatus !== "LOADING" && (
                <>
                  <div className={`${BLOCK.current}__free-trial-banner`}>
                    <div className={`${BLOCK.current}__free-trial-banner-icon`}>
                      <FreeTrialInfoIcon />
                    </div>
                    <div>
                      <h3 dangerouslySetInnerHTML={{ __html: translate("free-trial-banner-title") }} />
                      <p>
                        {translate("free-trial-banner-content")}{" "}
                        <a
                          className={`${BLOCK.current}__free-trial-banner-link`}
                          href={`/${lang}/qbo-accounting/pricing`}
                        >
                          {translate("free-trial-banner-button")}
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className={`${BLOCK.current}__affiliate-banner`}>
                  <h2 className={`${BLOCK.current}__affiliate-banner-title`}>
                    {translate("affiliate-banner-title")}
                  </h2>
                  <p className={`${BLOCK.current}__affiliate-banner-content`}>
                    {translate("affiliate-banner-content")}
                  </p>
                  <a
                    className={`${BLOCK.current}__affiliate-banner-link primary-button`}
                    href={env.qboAffiliateLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {translate("affiliate-banner-link")}
                  </a>
                </div>
                </>
              )}
              {isPending && (
                <div className={`${BLOCK.current}__next-steps-banner`}>
                  <div className={`${BLOCK.current}__next-steps-banner-icon`}>
                    <img src={letterIcon} alt="" aria-hidden="true" />
                  </div>
                  <div>
                    <h3>{translate("oauth-callback-next-steps-title")}</h3>
                    <p>{translate("oauth-callback-next-steps-message")}</p>
                  </div>
                </div>
              )}
              <div className={`${BLOCK.current}__hero`}>
                <div className={`${BLOCK.current}__hero-logos`}>
                  <img
                    alt="Quickbooks logo"
                    src={qboHeroLogo}
                    className={`${BLOCK.current}__hero-qb-logo`}
                  />
                  <div className={`${BLOCK.current}__hero-pipe`} />
                  <img
                    alt="Moneris logo"
                    src={monerisHeroLogo}
                    className={`${BLOCK.current}__hero-moneris-logo`}
                  />
                </div>
                <p className={`${BLOCK.current}__hero-tagline`}>
                  {translate("hero-tagline")}
                </p>
              </div>
              <h2>{translate("summary-title")}</h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: translate("summary-content"),
                }}
              />
            </div>
          </div>

          <div className={`${BLOCK.current}__section`}>
            <div className={`${BLOCK.current}__left`}></div>
            <div id="features" className={`${BLOCK.current}__content`}>
              <h2>{translate("features-title")}</h2>
              <div className={`${BLOCK.current}__features-grid`}>
                <div className={`${BLOCK.current}__feature-card`}>
                  <StraightforwardSetupIcon />
                  <div>
                    <h3>{translate("features-straightforward-setup-title")}</h3>
                    <p>{translate("features-straightforward-setup-content")}</p>
                  </div>
                </div>
                <div className={`${BLOCK.current}__feature-card`}>
                  <OvernightSyncIcon />
                  <div>
                    <h3>{translate("features-automatic-overnight-sync-title")}</h3>
                    <p>{translate("features-automatic-overnight-sync-content")}</p>
                  </div>
                </div>
                <div className={`${BLOCK.current}__feature-card`}>
                  <SingleLocationIcon />
                  <div>
                    <h3>{translate("features-single-location-title")}</h3>
                    <p>{translate("features-single-location-content")}</p>
                  </div>
                </div>
                <div className={`${BLOCK.current}__feature-card`}>
                  <LiveSupportIcon />
                  <div>
                    <h3>{translate("features-live-support-title")}</h3>
                    <p>{translate("features-live-support-content")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${BLOCK.current}__section`}>
            <div className={`${BLOCK.current}__left`}></div>
            <div id="pricing" className={`${BLOCK.current}__content`}>
              <h2>{translate("pricing-landing-title")}</h2>
              <div className={`${BLOCK.current}__pricing-grid`}>
                <div className={`${BLOCK.current}__pricing-card`}>
                  <h3>{translate("pricing-landing-monthly-title")}</h3>
                  <p>{translate("pricing-landing-monthly-description")}</p>
                  <p className={`${BLOCK.current}__pricing-card-price`}>
                    {translate("pricing-landing-monthly-price")}
                  </p>
                  <p className={`${BLOCK.current}__pricing-card-footnote`}>
                    &nbsp;
                  </p>
                </div>
                <div className={`${BLOCK.current}__pricing-card`}>
                  <h3>{translate("pricing-landing-annual-title")}</h3>
                  <p>{translate("pricing-landing-annual-description")}</p>
                  <p className={`${BLOCK.current}__pricing-card-price`}>
                    {translate("pricing-landing-annual-price")}
                    <span className={`${BLOCK.current}__pricing-card-save`}>
                      {translate("pricing-landing-annual-save")}
                    </span>
                  </p>
                  <p className={`${BLOCK.current}__pricing-card-footnote`}>
                    {translate("pricing-landing-annual-footnote")}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={`${BLOCK.current}__section`}>
            <div className={`${BLOCK.current}__left`}></div>
            <div id="how-to-guides" className={`${BLOCK.current}__content`}>
              <h2>{translate("how-to-guide-title")}</h2>
              <p>{translate("how-to-guide-description")}</p>
              <ul>
                <li>{translate("how-to-guide-description-bullet-1")}</li>
                <li>{translate("how-to-guide-description-bullet-2")}</li>
              </ul>
              <Accordion
                defaultCollapsed={true}
                header={translate("how-to-setup-existing-title")}
              >
                <ol>
                  <li>{translate("how-to-setup-existing-step-1")}</li>
                  <li>{translate("how-to-setup-existing-step-2")}</li>
                  <li>{translate("how-to-setup-existing-step-3")}</li>
                  <li>{translate("how-to-setup-existing-step-4")}</li>
                  <li>{translate("how-to-setup-existing-step-5")}</li>
                  <li>{translate("how-to-setup-existing-step-6")}</li>
                  <li>{translate("how-to-setup-existing-step-7")}</li>
                </ol>
              </Accordion>
              <Accordion
                defaultCollapsed={true}
                header={translate("how-to-setup-new-title")}
              >
                <ol>
                  <li>
                    {translate("how-to-setup-new-step-1-prefix")}
                    <a
                      href="https://quickbooks.intuit.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {translate("how-to-setup-new-step-1-link")}
                    </a>
                  </li>
                  <li>{translate("how-to-setup-new-step-2")}</li>
                  <li>{translate("how-to-setup-new-step-3")}</li>
                  <li>{translate("how-to-setup-new-step-4")}</li>
                  <li>{translate("how-to-setup-new-step-5")}</li>
                  <li>{translate("how-to-setup-new-step-6")}</li>
                  <li>{translate("how-to-setup-new-step-7")}</li>
                  <li>{translate("how-to-setup-new-step-8")}</li>
                </ol>
              </Accordion>
              <Accordion
                defaultCollapsed={true}
                header={translate("how-to-disconnect-title")}
              >
                <ol>
                  <li>{translate("how-to-disconnect-step-1")}</li>
                  <li>{translate("how-to-disconnect-step-2")}</li>
                  <li>{translate("how-to-disconnect-step-3")}</li>
                  <li>{translate("how-to-disconnect-step-4")}</li>
                  <li>{translate("how-to-disconnect-step-5")}</li>
                </ol>
              </Accordion>
              <Accordion
                defaultCollapsed={true}
                header={translate("how-to-cancel-title")}
              >
                <ol>
                  <li>{translate("how-to-cancel-step-1")}</li>
                  <li>{translate("how-to-cancel-step-2")}</li>
                  <li>{translate("how-to-cancel-step-3")}</li>
                  <li>{translate("how-to-cancel-step-4")}</li>
                  <li>{translate("how-to-cancel-step-5")}</li>
                </ol>
              </Accordion>
              <a
                className={`${BLOCK.current}__how-to-guide-link`}
                href={
                  lang === "fr"
                    ? "https://moneris-externalfr-hc.lighthouse-cloud.com/fr/article/moneris-quick-books-online-integration-overview-169899"
                    : "https://moneris-hc.lighthouse-cloud.com/article/moneris-quick-books-online-integration-overview-169899"
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                {translate("how-to-guide-link")} <RightArrow />
              </a>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </AuthenticatedTemplate>
  );
}

export default QBO_Accounting;
